import * as React from 'react';

const CalculatorLogoSVGR = () => (
  <svg
    width={99}
    height={120}
  >
    <defs>
      <path d='M0 0h69v100H0z' />
      <path d='M0 100h69V0H0z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <path fill='#00604B' d='M46.292 77.143h2.875V62.857h-2.875z' />
      <path
        fill='#00604B'
        d='M40.542 71.429h14.375V68.57H40.542zM43.587 108.571l-2.087-2.073L51.872 96.19l2.086 2.074z'
      />
      <path
        fill='#00604B'
        d='M51.872 108.571 41.5 98.264l2.087-2.074 10.371 10.308zM74.083 71.429h14.375V68.57H74.083zM77.128 108.571l-2.086-2.073L85.413 96.19l2.087 2.074z'
      />
      <g transform='translate(30 20)'>
        <path
          d='M48.313 76.749c.75.744.75 1.949 0 2.693a1.924 1.924 0 0 1-2.71 0 1.896 1.896 0 0 1 0-2.693 1.924 1.924 0 0 1 2.71 0M56.938 84.368c.75.744.75 1.949 0 2.693a1.924 1.924 0 0 1-2.71 0 1.896 1.896 0 0 1 0-2.693 1.924 1.924 0 0 1 2.71 0'
          fill='#00604B'
        />
        <path
          d='M5.243 2.857c-1.305 0-2.368 1.053-2.368 2.347v89.592c0 1.294 1.063 2.347 2.368 2.347h58.514c1.306 0 2.368-1.053 2.368-2.347V5.204c0-1.294-1.062-2.347-2.368-2.347H5.243ZM63.745 100H5.255C2.359 100 0 97.663 0 94.79V5.21C0 2.336 2.358 0 5.256 0h58.49C66.642 0 69 2.337 69 5.21v89.58c0 2.873-2.357 5.21-5.255 5.21Z'
          fill='#00604B'
        />
        <path
          d='M2.875 31.429h63.25V12.38H2.875v19.048ZM0 34.286h69V9.524H0v24.762ZM1.917 67.619h66.125v-2.857H1.917z'
          fill='#00604B'
        />
        <path
          fill='#00604B'
          d='M32.583 98.095h2.875V32.381h-2.875zM39.292 23.81h3.833v-2.858h-3.833v2.858Zm7.666 0h3.834v-2.858h-3.834v2.858Zm7.667 0h3.833v-2.858h-3.833v2.858Z'
        />
      </g>
      <path
        d='M20 0C8.953 0 0 8.953 0 20s8.953 20 20 20 20-8.953 20-20S31.047 0 20 0Zm5 30H15a1.875 1.875 0 0 1 0-3.75h3.125V15.375l-1.148.766c-.86.57-2.024.273-2.602-.586-.57-.797-.336-1.961.523-2.532l4.063-2.707a1.869 1.869 0 0 1 1.925-.093c.606.324.989.965.989 1.652V26.25H25A1.875 1.875 0 0 1 25 30Z'
        fill='#19A683'
        fillRule='nonzero'
      />
    </g>
  </svg>
);

export default CalculatorLogoSVGR;
